export default __webpack_public_path__ + "static/media/0338.1eec2f42.jpg";